import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { SkipBack } from "lucide-react";
import Formvalidators from "./validators/Formvalidators";

const BanquetHallForm = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    tentativeDate: "",
    description: "",
    companyName: "",
    event: "",
    guest: "",
    roomOfNumber: ""
  });

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    name: "Name Field Is Required",
    phone: "Phone Field Is Required",
    email: "Email Field Is Required",
    tentativeDate: "TentativeDate Field Is Required",
    event: "Event type Field Is Required",
    guest: "Number of Guest Field Is Required",
  });

  const inputData = (e) => {
    const { name, value } = e.target;

    // Always update form data
    setData((prev) => ({
      ...prev,
      [name]: value
    }));

    // Validate only required fields
    if (["name", "email", "phone", "tentativeDate", "event", "guest"].includes(name)) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: Formvalidators(e)
      }));
    }
  };

  const clickme = async (e) => {
    e.preventDefault();
    try {
      const error = Object.values(errorMessage).find((x) => x.length > 0);
      if (error) {
        setShow(true);
      } else {
        let res = await fetch("/api/enquery", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        });
        res = await res.json();

        if (res.result === "Done") {
          toast.success("Thank you! Your query has been submitted.");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } catch (error) {
      alert("Something went wrong");
    }
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="container mb-5 form-div" style={{ background: "#fff" }}>
        <div className="container-fluid" style={{ background: "#fff" }}>
          <h2 className="text-center mb-4" style={{ color: "#AD8B3A" }}>Enquiry</h2>
          <form className="mx-auto" style={{ maxWidth: "1000px" }}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <input onChange={inputData} type="text" name="name" placeholder="Name*" className="form-control custom-input" />
                {show && errorMessage.name && <sup className="text-danger">{errorMessage.name}</sup>}
              </div>
              <div className="col-md-4 mb-3">
                <input onChange={inputData} type="text" name="email" placeholder="Email*" className="form-control custom-input" />
                {show && errorMessage.email && <sup className="text-danger">{errorMessage.email}</sup>}
              </div>
              <div className="col-md-4 mb-3">
                <input onChange={inputData} type="number" name="phone" placeholder="Mobile Number*" className="form-control custom-input" />
                {show && errorMessage.phone && <sup className="text-danger">{errorMessage.phone}</sup>}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 mb-3">
                <label className="form-label custom-input">Tentative Date*</label>
                <input onChange={inputData} type="date" name="tentativeDate" className="form-control custom-input" />
                {show && errorMessage.tentativeDate && <sup className="text-danger">{errorMessage.tentativeDate}</sup>}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label custom-input">Event Type*</label>
                <select name="event" onChange={inputData} className="form-control custom-input">
                  <option value="">Select &#11163;</option>
                  <option value="Marriage Hall">Marriage Hall</option>
                  <option value="Party Hall">Party Hall</option>
                  <option value="Reception Hall">Reception Hall</option>
                  <option value="Others">Others</option>
                </select>
                {show && errorMessage.event && <sup className="text-danger">{errorMessage.event}</sup>}
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label custom-input">Number Of Guests*</label>
                <select name="guest" onChange={inputData} className="form-control custom-input">
                  <option value="">Select &#11163;</option>
                  <option>Up to 10</option>
                  <option>11-25</option>
                  <option>26-50</option>
                  <option>51-100</option>
                  <option>101-200</option>
                  <option>Other</option>
                </select>
                {show && errorMessage.guest && <sup className="text-danger">{errorMessage.guest}</sup>}
              </div>
            </div>

            <div className="row mb-3">
              <div className="form-check col-md-4 mb-3">
                <label className="form-check-label chek-box">Do you require rooms?</label>
              </div>
              <div className="col-md-8 mb-3">
                <input onChange={inputData} type="number" name="roomOfNumber" placeholder="Estimated Number of Rooms" className="form-control custom-input" />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-12 mb-3">
                <input type="text" name="description" onChange={inputData} placeholder="Briefly Describe Your Event Requirements" className="form-control custom-input" />
              </div>
            </div>

            <div className="row mb-3">
              <div className="form-check col-md-4 mb-3">
                <label className="form-check-label chek-box">Is this a corporate query?</label>
              </div>
              <div className="col-md-8 mb-3">
                <input onChange={inputData} type="text" name="companyName" placeholder="Company Name" className="form-control custom-input" />
              </div>
            </div>

            <div className="form-btn">
              <button type="submit" className="btn-primary" onClick={clickme}>Submit</button>
            </div>
          </form>

          <Link to="/"   title="backToHome" className="banquet-query-back-btn">
            <SkipBack />
          </Link>

          <p className="text-center form-para">You may also contact us at email <a href="mailto:info@thegrandshobha.com">info@thegrandshobha.com</a></p>
        </div>
      </div>
    </>
  );
};

export default BanquetHallForm;


